export default __webpack_public_path__ + "static/appliances_b.5880a648dd21cd82424774a4abcf1313.svg";